import { ProductClass } from '../../graphQL/types/shared';
import {
  GraphExportType,
} from '../../Utils';
import {
  IProcessedNode,
  NodeSizing,
} from '../../workerStore/feasibility/Utils';
import {
  HideExports,
  YAxisMeasure,
} from '../Utils';

export interface IExportInput {
  year: number;
  nodes: IProcessedNode[];
  total: number;
  width: number;
  height: number;
  hideExports: HideExports;
  xAxisMax: number;
  xAxisMin: number;
  yAxisMax: number;
  yAxisMin: number;
  yAverage: number;
  yAxisMeasure: YAxisMeasure;
  exportType: GraphExportType;
  title: string;
  nodeSizing: NodeSizing;
  productClass: ProductClass;
}

export const leftMargin = 100;
export const bottomMargin = 100;
export const topMargin = 50;
export const rightMargin = 100;

export const tickLength = 13;

// TODO: make this into a CSS variable
export const tickColor = '#ccc';
